<template>
    <div>
        <el-table :data="devices" border>
            <el-table-column align="center" label="设备编号" prop="deviceNo" />
            <el-table-column align="center" label="型号">
                <template slot-scope="scope">
                    {{ scope.row.deviceType || '--' }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="注册时间"
                prop="createTime"
            />
            <el-table-column align="center" label="版本" prop="version" />
            <el-table-column align="center" label="容量/G" prop="capacity" />
            <el-table-column align="center" label="在线">
                <template slot-scope="scope">
                    {{ STATUS_MAP[scope.row.status] }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="代理商">
                <template slot-scope="scope">
                    {{ scope.row.agentName || '--' }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="施工点地址">
                <template slot-scope="scope">
                    {{ scope.row.location || '--' }}
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                width="150"
                label="授权通道/物理通道"
            >
                <template slot-scope="scope">
                    {{ scope.row.channel || scope.row.noFusionChannel }}/{{
                        scope.row.maxChannel
                    }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="授权信息">
                <template slot-scope="scope">
                    <p :title="scope.row.comment">
                        {{ AUTH_MAP[scope.row.auth] }}{{ ' ' }}
                        {{
                            scope.row.comment.length > 15
                                ? scope.row.comment.substr(0, 15) + '...'
                                : scope.row.comment
                        }}
                    </p>
                    <p v-if="scope.row.auth == AUTH_PROBATION">
                        {{ scope.row.endTime }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column align="center" width="200" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" @click="clickEditAuth(scope.row)"
                        >修改授权</el-button
                    >
                    <el-button size="mini" @click="clickDownload(scope.row)"
                        >下载授权</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <DialogEditAuth
            :form="form"
            :maxChannel="maxChannel"
            :visible="visible"
            @on-close="changeVisible"
            @on-ok="handleSubmit"
        />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { AUTH_MAP, AUTH_PROBATION, STATUS_MAP } from '../../libs/enum.js';
import { api } from '../../service';
import DialogEditAuth from '../../components/edit-auth';

const { mapState, mapActions } = createNamespacedHelpers('device');

export default {
    components: { DialogEditAuth },
    data() {
        return {
            AUTH_MAP,
            AUTH_PROBATION,
            STATUS_MAP,
            visible: false,
            form: {},
            maxChannel: 0,
        };
    },
    computed: {
        ...mapState({
            devices: (state) => state.devices,
        }),
    },
    methods: {
        ...mapActions(['getDevices']),
        clickEditAuth(data) {
            this.changeVisible(true);
            const { agentId, maxChannel, siteId } = data;
            const isAgent = agentId ? 1 : siteId ? 0 : 1;
            this.form = {
                ...data,
                isAgent,
                channel: data.channel || data.noFusionChannel,
                noFusionChannel: data.noFusionChannel === 0 ? 0 : 1,
            };
            this.maxChannel = maxChannel;
        },
        clickDownload({ deviceId }) {
            const token = localStorage.getItem('token');
            window.open(
                `${api.device.download}?token=${token}&deviceId=${deviceId}`
            );
        },
        changeVisible(visible) {
            this.visible = visible;
            !visible ? (this.form = {}) : void 0;
        },
        handleSubmit() {
            this.getDevices();
        },
    },
};
</script>
